import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, sync } from 'vuex-pathify';
import { mdRender } from "../../functions/remarkable";
export default {
  name: 'GuestReceiptPinEntry',
  components: {
    FibFindOutMore: require('@/components/FindOutMore').default
  },
  data: function data() {
    return {
      // TODO: Make sure all this stuff is loaded dynamically for each branch/company after FC components signed off
      cover: true,
      error: null,
      isRestaurant: true,
      pinMask: '',
      pinNumber: '',
      pinNumberHelpActive: false,
      receiptImageCaptureAvailable: false,
      slide: '1',
      useParallax: false
    };
  },
  computed: {
    branchDetails: get('config/branchDetails'),
    demoReceipt: get('checkIn/demoReceipt'),
    eposData: get('checkIn/eposData'),
    logoRestaurant: get('theme/logo'),
    showAboutVisit: get('checkIn/showAboutVisit'),
    survey: sync('settings/selectedSurvey'),
    transactionRef: sync('checkIn/transactionRef'),
    visitDetails: get('checkIn/getVisitDetails'),
    pinMasks: function pinMasks() {
      var _this$$store$getters$;

      return (((_this$$store$getters$ = this.$store.getters['questions/getSurvey']) === null || _this$$store$getters$ === void 0 ? void 0 : _this$$store$getters$.pinFormats) || []).map(function (a) {
        return a.format;
      }).map(function (f) {
        return f.toUpperCase();
      }).sort(function (a, b) {
        return a.length - b.length;
      });
    },
    bgImage: function bgImage() {
      return this.$store.getters['theme/bgImage'];
    },
    headerStyles: function headerStyles() {
      return {
        background: "linear-gradient(130deg, ".concat(this.theme.gradientColorStart, ", ").concat(this.theme.gradientColorStart, " 20%, ").concat(this.theme.gradientColorEnd, ")")
      };
    },
    location: function location() {
      var _this$branchDetails;

      return ((_this$branchDetails = this.branchDetails) === null || _this$branchDetails === void 0 ? void 0 : _this$branchDetails.name) || '';
    },
    logoStyle: function logoStyle() {
      if (this.isRestaurant) {
        return {
          width: '50px',
          position: 'absolute',
          left: '0',
          top: '0'
        };
      }

      return '90px';
    },
    validForm: function validForm() {
      var _this$pinNumber;

      // Check to see if we have a pinNumber or a pinMask (pinMask will be removed if pinNumber length gets to long)
      if (!this.pinNumber || !this.pinMask) {
        return false;
      }

      var pinMaskLength = this.pinMask.length; // Remove just a trailing slash if present - this can occur if you enter too many '-' delimited sections and then hit backspace.

      var pinNumber = ((_this$pinNumber = this.pinNumber) !== null && _this$pinNumber !== void 0 ? _this$pinNumber : '').replace(/-$/, '');
      return pinNumber.length === pinMaskLength;
    },
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    }
  },
  watch: {
    pinNumber: function pinNumber(val) {
      var _replace;

      var noDashValLength = (_replace = (val || '').replace(/(-)/g, '')) === null || _replace === void 0 ? void 0 : _replace.length;

      if (noDashValLength === 0) {
        return;
      } // filter the pinmasks if they are still able to apply to the lenght fo the string,
      // Once filtered take the first one and apply it as these are now sorted by length.


      this.pinMask = this.pinMasks.filter(function (pm) {
        // Strip out the dashs so we get a true string length
        var pinMaskStripped = pm.replace(/(-)/g, '');
        return pinMaskStripped.length >= noDashValLength;
      })[0];
    }
  },
  mounted: function mounted() {
    this.transactionRef = null; // Set the pinMask to the first item in the pinMasks Array

    this.pinMask = this.pinMasks[0];
  },
  methods: {
    resetPinMasks: function resetPinMasks() {
      this.pinMask = this.pinMasks[0];
      this.pinNumber = '';
    },
    fetchTransactionData: function fetchTransactionData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // set loading state
                _this.transactionRef = _this.pinNumber;

                if (_this.transactionRef) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _this.$q.loading.show({
                  message: _this.$t('common.misc.loading')
                });

                _context.next = 6;
                return _this.$store.dispatch('checkIn/fetchTransactionData');

              case 6:
                res = _context.sent;

                // remove loading state and return
                _this.$q.loading.hide();

                return _context.abrupt("return", res);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2$eposData, _this2$eposData2, _this2$eposData2$pin, _this2$eposData3, _this2$eposData3$pin;

        var _this2$eposData4, _this2$eposData4$pin, nextPage;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.fetchTransactionData();

              case 2:
                if (!(!((_this2$eposData = _this2.eposData) !== null && _this2$eposData !== void 0 && _this2$eposData.pin || false) || ((_this2$eposData2 = _this2.eposData) === null || _this2$eposData2 === void 0 ? void 0 : (_this2$eposData2$pin = _this2$eposData2.pin) === null || _this2$eposData2$pin === void 0 ? void 0 : _this2$eposData2$pin.validData) != true && ((_this2$eposData3 = _this2.eposData) === null || _this2$eposData3 === void 0 ? void 0 : (_this2$eposData3$pin = _this2$eposData3.pin) === null || _this2$eposData3$pin === void 0 ? void 0 : _this2$eposData3$pin.validData) != 1)) {
                  _context2.next = 5;
                  break;
                }

                _this2.error = _this2.$t('error.pin.' + (((_this2$eposData4 = _this2.eposData) === null || _this2$eposData4 === void 0 ? void 0 : (_this2$eposData4$pin = _this2$eposData4.pin) === null || _this2$eposData4$pin === void 0 ? void 0 : _this2$eposData4$pin.validData) || 'INVALID-PIN'));
                return _context2.abrupt("return");

              case 5:
                _context2.next = 7;
                return _this2.$store.dispatch('checkIn/nextPage');

              case 7:
                nextPage = _context2.sent;

                _this2.$router.push(nextPage);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    noCodeSubmit: function noCodeSubmit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var nextPage;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$store.dispatch('checkIn/nextPage');

              case 2:
                nextPage = _context3.sent;

                _this3.$router.push(nextPage);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    renderText: function renderText(text) {
      return mdRender(text);
    }
  }
};